import { useCallback, useEffect, useState } from 'react';
import { getPPAServiceDetail } from 'api/ppaOnboarding';
import { IPPAServiceDetailResponse } from 'types/ppaOnboarding';

const useGetPPAServiceDetail = (
    autoFetch = true,
    scheduleToken?: string,
): [IPPAServiceDetailResponse | undefined, boolean, string, () => Promise<void>] => {
    const [data, setData] = useState<IPPAServiceDetailResponse | undefined>();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string>('');
    const fetch = useCallback(async () => {
        try {
            setLoading(true);
            const res = await getPPAServiceDetail(scheduleToken);
            if (res && !res.error) {
                setData(res.data?.data);
            } else {
                setError(res?.error);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    }, [scheduleToken]);

    useEffect(() => {
        if (autoFetch) {
            fetch();
        }
    }, [autoFetch, fetch]);

    return [data, loading, error, fetch];
};

export default useGetPPAServiceDetail;
